<section>
  <div class="fallback-header">
    <h1>{{ displayObj.title }}</h1>
    <pdq-icon icon="close" class="close-icon" size="24" color="flintDark" (click)="close()"></pdq-icon>
  </div>

  <div class="fallback-content">
    @switch (mode) { @case ('on') {
    <span style="flex-direction: column; display: flex; gap: 8px">
      <span> {{ displayObj.body }} </span>
      <pdq-input variant="form" [formControl]="name"></pdq-input>
      Fallback rate per delivery
      <pdq-input-arrows [formControl]="rate" placeholder="0.00" widthSize="large" [symbol]="currency | currencySign">
      </pdq-input-arrows>
    </span>
    } @case ('off') {
    <span> {{ displayObj.body }} </span>
    } }
  </div>

  <div class="fallback-actions">
    <pdq-button label="Cancel" variant="light" (onClick)="close()"></pdq-button>
    <pdq-button
      label="{{ displayObj.buttonText }}"
      variant="primary"
      [disabled]="!rate.value && mode === 'on'"
      (onClick)="onClick(mode)"></pdq-button>
  </div>
</section>
